module.exports = __webpack_public_path__ + "img/hat_male_cap_mask.54defabd.png";